export const FETCH_DEVICES = "app/DEVICE_SETTINGS/FETCH_DEVICES";
export const FETCH_DEVICES_SUCCESS =
  "app/DEVICE_SETTINGS/FETCH_DEVICES_SUCCESS";
export const FETCH_DEVICES_FAILURE =
  "app/DEVICE_SETTINGS/FETCH_DEVICES_FAILURE";

export const TOGGLE_DEVICE_STATUS = "app/DEVICE_SETTINGS/TOGGLE_DEVICE_STATUS";
export const TOGGLE_DEVICE_STATUS_SUCCESS =
  "app/DEVICE_SETTINGS/TOGGLE_DEVICE_STATUS_SUCCESS";
export const TOGGLE_DEVICE_STATUS_FAILURE =
  "app/DEVICE_SETTINGS/TOGGLE_DEVICE_STATUS_FAILURE";
